export const alert = {
  namespaced: true,
  state: {
    type: null,
    message: null,
  },
  actions: {
    success({ commit }, message) {
      commit('success', message);
    },
    info({ commit }, message) {
      commit('info', message);
    },
    error({ commit }, message) {
      commit('error', message);
    },
    clear({ commit }, message) {
      commit('success', message);
    },
  },
  mutations: {
    success(state, message) {
      state.type = 'success';
      state.message = message;
    },
    info(state, message) {
      state.type = 'info';
      state.message = message;
    },
    error(state, message) {
      state.type = 'danger';
      // debugger
      if (typeof message === 'string') {
        state.message = message;
      } else if (
        typeof message === 'object' &&
        (message.message || message.msg)
      ) {
        state.message = message.msg ? message.msg : message.message;
      } else {
        state.message = 'Error occured';
      }
    },
    clear(state) {
      state.type = null;
      state.message = null;
    },
  },
};
